export default defineNuxtPlugin(nuxtApp => {
  const router = useRouter()

  router.onError((error, to) => {
    const msg = error?.message || ''
    if (
      msg.includes('Failed to fetch dynamically imported module') ||
      msg.includes('Importing a module script failed')
    ) {
      if (!to?.fullPath) {
        window.location.reload();
      } else {
        // 🔴 2026-10-07 `to.fullPath` 를 그대로 넣으면 안 된다 — 라우터 경로라 **basePath(`/v`) 가 빠져 있다.**
        //   종전엔 `/payment/step1` 처럼 웹앱 밖 주소로 튕겼다. `resolve().href` 는 basePath 를 붙여 준다.
        window.location.href = router.resolve(to.fullPath).href;
      }
    }
  })
})
